import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { errorPageActions } from './error-page.actions';
import { Container } from '../grid/container';
import { Headline } from '../layout/headline';
import { ManageTitle } from '../manage-title';
import { isString } from '~/utils';
import { CookiesErrorMessage } from './CookiesErrorMessage';

import accountStyles from '../layout/SidebarLayout.scss';
import layoutStyles from '../layout/Layout.scss';

const mapStateToProps = ({
  services: {
    config: { headlineTitle },
  },
  appointment: {
    draft: {
      appointmentType: { name },
    },
  },
}) => ({ headlineTitle, appointmentTypeName: name });

const mapDispatchToProps = {
  dispatchClearErrorStatus: errorPageActions.clearErrorStatus,
};

export const CookiesError = connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  class extends PureComponent {
    constructor() {
      super();
      this.cookieListener = this.cookieListener.bind(this);
    }

    static displayName = 'CookiesError';

    componentDidMount() {
      document.body.addEventListener('jl-privacy:cookiePreferences', this.cookieListener);
    }

    componentWillUnmount() {
      document.body.removeEventListener('jl-privacy:cookiePreferences', this.cookieListener);
    }

    cookieListener() {
      this.props.dispatchClearErrorStatus();
    }

    render() {
      const { headlineTitle, appointmentTypeName } = this.props;
      const isManageAppointments = window.REACT_APP_SERVICE_NAME === 'MANAGE_APPOINTMENTS';

      return isManageAppointments ? (
        <div className={accountStyles.content}>
          <ManageTitle title="My appointments" />
          <CookiesErrorMessage />
        </div>
      ) : (
        <main className={layoutStyles.PersonalStyling}>
          <Headline title={isString(headlineTitle) ? headlineTitle : appointmentTypeName} />
          <Container>
            <CookiesErrorMessage />
          </Container>
        </main>
      );
    }
  },
);
